import React from "react";
import SubscriptionsCategoryPills from "components/Subscriptions/SubscriptionsCategoryPills/SubscriptionsCategoryPills";
import useSubscriptions from "lib/hooks/useSubscriptions/useSubscriptions";
import styles from "./SubscriptionsPillsSection.module.scss";

export default function SubscriptionsPillsSection({
  selectedSubscriptionTags,
  setSelectedSubscriptionTags,
  validatedCategoriesAndTags,
}) {
  const { defaultCategoriesAndTags } = useSubscriptions();

  // Use validated categories and tags if provided, otherwise fall back to default
  const categoriesToRender = validatedCategoriesAndTags ?? defaultCategoriesAndTags;

  return (
    <div className={styles.sectionContainer}>
      {categoriesToRender.map(([category, defaultTags]) => (
        <SubscriptionsCategoryPills
          key={category}
          category={category}
          defaultTags={defaultTags}
          selectedSubscriptionTags={selectedSubscriptionTags}
          setSelectedSubscriptionTags={setSelectedSubscriptionTags}
        />
      ))}
    </div>
  );
}
